import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grievance-dashboard',
  templateUrl: './grievance-dashboard.component.html',
  styleUrls: ['./grievance-dashboard.component.scss']
})
export class GrievanceDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
